import * as React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Grid from '@mui/material/Grid';
import CustomCard from './Card';
import Typography from '@mui/material/Typography';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', background: 'grey', borderRadius: '50%', marginRight: 10 }}
      onClick={onClick}
    >
      <ArrowForwardIosIcon />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', background: 'grey', borderRadius: '50%', marginLeft: 10 }}
      onClick={onClick}
    >
      <ArrowBackIosIcon />
    </div>
  );
}

export default function CardList({ places }) {
  const cardsByCategory = groupByCategory(places);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div>
      {Object.keys(cardsByCategory).map(category => (
        <section key={category}>
          <Typography variant="h4" gutterBottom sx={{ mt: 4 }}>
            {category}
          </Typography>
          <Slider {...settings}>
            {cardsByCategory[category].map((card, index) => (
              <div key={index}>
                <Grid container justifyContent="center">
                  <Grid item xs={12} sm={10} md={10}>
                    <CustomCard 
                      images={card.images} 
                      title={card.title} 
                      description={card.description} 
                      actions={card.actions}
                    />
                  </Grid>
                </Grid>
              </div>
            ))}
          </Slider>
        </section>
      ))}
    </div>
  );
}

const groupByCategory = (cards) => {
  return cards.reduce((group, card) => {
    const { category } = card;
    group[category] = group[category] ?? [];
    group[category].push(card);
    return group;
  }, {});
};
